import angular from 'angular';
import {isDEMO, popError} from '../../base/utils';
require('../../common/sentry_browser');

let strAppName = 'app';
let strCtrName = 'ctr';
angular.module(strAppName, ['ngSentry'])
  .controller(strCtrName, loginController);

loginController.$inject = ['$http', '$window'];

/**
 * Login Controller
 *
 * @param {*} $http - $http service, for post, get request etc
 * @param {*} $window - $window service, used to replace default window function
 */
function loginController($http, $window) {
  // eslint-disable-next-line no-invalid-this
  let vm = this;

  /**
   * Login and redirect to the dashboard
   *
   */
  vm.loginUser = function() {
    vm.isLoading = true;
    $http({
      method: 'POST',
      url: '/api/v1/manager/login',
      data: vm.userData,
      headers: {'Content-Type': 'application/json'}
    }).then(
      function successCallback(response) {
        $window.location.href = '/manager/';
      },

      function errorCallback(response) {
        vm.isLoading = false;
        popError(response);
      }
    );
  };
  if (isDEMO()) {
    vm.userData = {
      userName: 'manager',
      password: 'password'
    };
  }
}
